import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import { Chip, TableCell } from "@mui/material";
import "../../Styles/style.css";
import "./Ticket.css";
import AdminApiModule from "../../components/AdminApi/Api/api";
import { Button, Snackbar, Alert } from "@mui/material";
import TicketEditPincodePopup from "../../components/AdminApi/ticketEditPincodePopup";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import BasicDateRangePicker from "../../components/common/datepicker";
import moment from "moment";
import CloseTicketRemarksModal from "../../components/Components/CloseTicketRemark";
import AssignTechnicianPopup from "../../components/AdminApi/Api/assignTechnicianPopup";
import RemarksPopup from "../../components/AdminApi/Api/RemarksPopup";
import DeleteAlertDialogModal from "../../components/Components/DeleteAlert";
import DeleteIcon from "@mui/icons-material/Delete";
import UpdateIcon from "@mui/icons-material/Update";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/styles";
import FileUploadErrors from "../../components/FileUploadErrors";
import axios from "axios";
import { BASE_URL } from "../../components/config/config";
import InputBase from "@mui/material/InputBase";
import { withStyles } from "@mui/styles";
import RebookModal from "../../components/Components/RebookMoadl";
import JobCompletedModal from "../../components/Components/CloseTicketRemark";

// Import permission utilities
import {
  canViewTickets,
  canViewAllTickets,
  canViewNormalTickets,
  canUpdateTicket,
  canDeleteTicket,
  canAssignUnassignTicket,
  canBroadcastTicket,
  canCloseTicket,
  canRemarkTicket,
  canViewContactNumber,
  hasFullAccess,
} from "../../utility/permissionUtils";
import TicketFilters from "./Filters/TicketFilters";

const CustomFilter = withStyles({
  filter: {
    background: "red",
  },
})(InputBase);

const Input = styled("input")({
  display: "none",
});

const stylesCss = {
  inputBox: {
    width: "100%",
    marginBottom: "10px",
  },
  gridStyle: {
    width: "80%",
    margin: "auto",
  },
  paddingInnerGrids: {
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingTop: "10px",
  },
  actionButton: {
    minWidth: "140px",
    height: "40px",
    fontSize: "14px",
    margin: "2px",
    textTransform: "none",
    whiteSpace: "nowrap",
  },
  smallActionButton: {
    minWidth: "40px",
    height: "40px",
    margin: "2px",
  },
};

const options = {
  filterType: "dropdown",
  filter: true,
  download: true,
  downloadOptions: {
    filterOptions: {
      useDisplayedRowsOnly: true,
      useDisplayedColumnsOnly: true,
    },
  },
  customFilterMenuRender: (filterValue, onFilterUpdate, column) => {
    return (
      <CustomFilter
        value={filterValue || ""}
        onChange={(event) => onFilterUpdate(event.target.value)}
        placeholder={`Filter ${column.label}`}
      />
    );
  },
  downloadProps: {
    filterOptions: {
      useDisplayedRowsOnly: true,
      useDisplayedColumnsOnly: true,
    },
  },
};

const Tickets = () => {
  const navigate = useNavigate();
  const reduxState = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state.AdminReducer);
  const userPermissions = globalState?.adminDetails?.role_id?.permissions;

  const [ticketsList, setTicketsList] = useState([]);
  const [ticketObj, setTicketObj] = useState([]);
  const [centerlist, setCenterlist] = useState([]);
  const [isBroadcasted, setIsBroadcasted] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isJobCompletedModalOpen, setIsJobCompletedModalOpen] = useState(false);
  const [currentTicketId, setCurrentTicketId] = useState(null);
  const [autoTriggerFilter, setAutoTriggerFilter] = useState(true);
  const [isEditOpenAddressPincode, setIsEditOpenAddressPincode] =
    useState(false);
  const [isEditOpenTicketDetails, setIsEditOpenTicketDetails] = useState({});
  const [isPincodeUpdating, setIsPincodeUpdating] = useState(false);
  const [getSingleTicketData, setGetSingleTicketData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTicketIds, setSelectedTicketIds] = useState([]);
  const [isAllRowsSelected, setIsAllRowsSelected] = useState(false);
  const [doesFileUploadErrorExists, setDoesFileUploadErrorExists] =
    useState(false);
  const [errorsList, setErrorsList] = useState({});
  const [selectedRowsClosingPrice, setSelectedRowsClosingPrice] = useState({});
  const [totalClosingPrice, setTotalClosingPrice] = useState(0);
  const [isApiButtonVisible, setIsApiButtonVisible] = useState(false);
  const [isAssignTechnicianPopupOpen, setIsAssignTechnicianPopupOpen] =
    useState(false);
  const [isRemarksPopupOpen, setIsRemarksPopupOpen] = useState(false);
  const [isDeleteAlertPopupOpen, setIsDeleteAlertPopupOpen] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("Ticket");
  const [
    ticketDetailsForAssignTechnician,
    setTicketDetailsForAssignTechnician,
  ] = useState({});
  const [isTechnicianAssigning, setIsTechnicianAssigning] = useState(false);
  const [technicianList, setTechnicianList] = useState([]);
  const [isCloseTicketRemarksModalOpen, setIsCloseTicketRemarksModalOpen] =
    useState(false);
  const [closingTicketId, setClosingTicketId] = useState("");
  const [deleteTicketId, setDeleteTicketId] = useState("");
  const [rebookTicketId, setRebookTicketId] = useState("");
  const [centerAssignId, setCenterAssignId] = useState("");
  const [isForChange, setIsForChange] = useState(false);
  const [openRebook, setOpenRebook] = useState(false);
  const [username, setUsername] = useState("");
  const [initialRemarks, setInitialRemarks] = useState("");
  const [processedname, setProcessedname] = useState("");
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [currentFilters, setCurrentFilters] = useState({});

  // Permission checks using utility functions
  const canViewTicketsPermission = canViewTickets(userPermissions);
  const canViewAllTicketsPermission = canViewAllTickets(userPermissions);
  const canViewNormalTicketsPermission = canViewNormalTickets(userPermissions);
  const canUpdateTicketPermission = canUpdateTicket(userPermissions);
  const canDeleteTicketPermission = canDeleteTicket(userPermissions);
  const canAssignUnassignTicketPermission =
    canAssignUnassignTicket(userPermissions);
  const canBroadcastTicketPermission = canBroadcastTicket(userPermissions);
  const canCloseTicketPermission = canCloseTicket(userPermissions);
  const canRemarkTicketPermission = canRemarkTicket(userPermissions);
  const canViewContactNumberPermission = canViewContactNumber(userPermissions);

  const [filters, setFilters] = useState({
    start_date: moment().subtract(1, "week").format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
  });
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const columns = [
    {
      name: "Created_at",
      label: "Created on",
      options: {
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Created On
          </TableCell>
        ),
        filter: false,
        sort: true,
      },
    },
    {
      name: "daysDifference",
      label: <b>Aging</b>,
      options: {
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Aging
          </TableCell>
        ),
        filter: false,
        sort: true,
      },
    },
    {
      name: "Image",
      label: "On-Site Image",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            On-Site Image
          </TableCell>
        ),
        customBodyRender: (value, id) => {
          return (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "auto auto auto auto",
                gridGap: "-10px !important",
              }}
            >
              {value && value.length > 0 && (
                <Button
                  className="text-transform-none"
                  variant="contained"
                  onClick={() => handleViewwTicket(value, value?._id)}
                >
                  Views
                </Button>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "ticket_id",
      label: "Ticket Id",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Request Id
          </TableCell>
        ),
      },
    },
    {
      name: "tstatus",
      label: "Ticket status",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Request status
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => {
          const technicianName =
            ticketsList[tableMeta.rowIndex]?.technicianName;

          if (value === "Technician Assigned") {
            return (
              <div>
                <Chip
                  label={value}
                  style={{ background: "#8FD1AD", marginBottom: "5px" }}
                />
                {technicianName && (
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#333",
                      marginTop: "4px",
                    }}
                  >
                    {technicianName}
                  </div>
                )}
              </div>
            );
          } else {
            const bgColor =
              value === "PENDING"
                ? "#FF9933"
                : value === "Technician Not Assigned"
                ? "#E76161"
                : value === "VERIFIED"
                ? "#00CC00"
                : value === "CLOSED"
                ? "#FF9999"
                : "red";

            return <Chip label={value} style={{ background: bgColor }} />;
          }
        },
      },
    },
    {
      name: "bstatus",
      label: "Broadcast status",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Broadcast status
          </TableCell>
        ),
      },
    },
    {
      name: "paidbypublic",
      label: "Paid By Public",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Paid By Public
          </TableCell>
        ),
      },
    },
    {
      name: "paidbytechnician",
      label: "Paid By technician",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Paid By Technician
          </TableCell>
        ),
      },
    },
    {
      name: "center_id",
      label: "Assigned Center",
      options: {
        filter: false,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Assigned Center
          </TableCell>
        ),
      },
    },
    {
      name: "Qr_Id",
      label: "Qr_Id ",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Qr_Id
          </TableCell>
        ),
      },
    },
    {
      name: "specific_requirements",
      label: "Specific  Requirements",
      options: {
        filter: true,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Specific Requirements
          </TableCell>
        ),
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Name
          </TableCell>
        ),
      },
    },
    {
      name: "phone",
      label: "Phone Number",
      options: {
        filter: true,
        sort: false,
        display:
          reduxState?.adminDetails?.role_id?.role === "SUPER_ADMIN" &&
          canViewContactNumberPermission,
        customHeadRender: () => (
          <TableCell
            style={{
              fontSize: "17px",
              fontWeight: "600",
              width: "0",
              padding: "0",
            }}
            align="center"
          >
            Phone Number
          </TableCell>
        ),
      },
    },
    {
      name: "alternate_phone_number",
      label: "Alternate Phone Number",
      options: {
        filter: true,
        sort: false,
        display:
          reduxState?.adminDetails?.role_id?.role === "SUPER_ADMIN" &&
          canViewContactNumberPermission,
        customHeadRender: () => (
          <TableCell
            style={{
              fontSize: "17px",
              fontWeight: "600",
              width: "0",
              padding: "0",
            }}
            align="center"
          >
            Alternate Phone Number
          </TableCell>
        ),
      },
    },
    {
      name: "pincode",
      label: "Pincode",
      options: {
        filter: true,
        sort: false,
        filterType: "multiselect",
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Pincode
          </TableCell>
        ),
      },
    },
    {
      name: "closingPrice",
      label: "Closing Price",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Closing Price
          </TableCell>
        ),
      },
    },
    {
      name: "tcreatedby",
      label: "Ticket Created By",
      options: {
        filter: true,
        sort: true,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Request Created By
          </TableCell>
        ),
      },
    },
    {
      name: "Center_QR",
      label: "Center QR Id ",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Center_QR
          </TableCell>
        ),
      },
    },
    {
      name: "timeprefrence",
      label: "Ticket Created By",
      options: {
        filter: false,
        sort: false,
        customHeadRender: () => (
          <TableCell
            style={{ fontSize: "17px", fontWeight: "600" }}
            align="center"
          >
            Timeprefrence
          </TableCell>
        ),
      },
    },
    {
      name: "action",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const ticketId = value?._id;
          const isBroadcastedValue = isBroadcasted[ticketId] || false;
          const isTechnicianAssigned = value?.is_technician_assigned;
          const ticketStatus = value?.ticket_status;
          const isClosed = ticketStatus === "CLOSED";
          const isAccepted = ticketStatus === "ACCEPTED";
          const isPending = ticketStatus === "PENDING";

          // Extract service and pincode from ticket data
          const serviceId = value?.service_provided_for?._id;
          const serviceName = value?.service_provided_for?.service_name;
          const pincode = value?.address_details?.pincode;

          // Determine technician assignment eligibility
          const canAssignTechnician =
            !isClosed && !isTechnicianAssigned && (isPending || isAccepted);
          const canChangeTechnician = !isClosed && isTechnicianAssigned;

          // Check if required data is available for technician assignment
          const hasRequiredDataForAssignment = serviceId && pincode;

          return (
            <>
              <div
                style={{
                  gap: "4px",
                  display: "flex",
                }}
              >
                {/* View Request Button */}
                {(canViewAllTicketsPermission ||
                  canViewNormalTicketsPermission) && (
                  <Button
                    sx={stylesCss.actionButton}
                    variant="contained"
                    onClick={() => handleViewTicket(value?._id)}
                  >
                    View Request
                  </Button>
                )}

                {/* Edit Request Button */}
                {canUpdateTicketPermission && (
                  <Button
                    sx={stylesCss.actionButton}
                    variant="contained"
                    onClick={() => handleEditTicket(value?._id)}
                  >
                    Edit Request
                  </Button>
                )}

                {/* Technician Assignment Buttons */}
                {!isClosed && (
                  <>
                    {/* Assign Technician Button - Show for pending or accepted but unassigned tickets */}
                    {canAssignTechnician &&
                      canAssignUnassignTicketPermission && (
                        <Tooltip
                          title={
                            !hasRequiredDataForAssignment
                              ? `Missing: ${!serviceId ? "Service" : ""}${
                                  !serviceId && !pincode ? " and " : ""
                                }${!pincode ? "Pincode" : ""}`
                              : `Assign technician for ${serviceName} in pincode ${pincode}`
                          }
                        >
                          <span>
                            <Button
                              sx={stylesCss.actionButton}
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                handleOpenTechnicianPopup(value, false)
                              }
                              disabled={!hasRequiredDataForAssignment}
                            >
                              Assign Technician
                              {!hasRequiredDataForAssignment && " ⚠️"}
                            </Button>
                          </span>
                        </Tooltip>
                      )}

                    {/* Change Technician Button - Show when technician is assigned */}
                    {canChangeTechnician &&
                      canAssignUnassignTicketPermission && (
                        <Tooltip
                          title={
                            !value?.assigned_ids?.assigned_center_id?._id
                              ? "Center information missing"
                              : `Change technician from ${value?.assigned_ids?.assigned_center_id?.center_name}`
                          }
                        >
                          <span>
                            <Button
                              sx={stylesCss.actionButton}
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                handleOpenTechnicianPopup(value, true)
                              }
                              disabled={
                                !value?.assigned_ids?.assigned_center_id?._id
                              }
                            >
                              Change Technician
                            </Button>
                          </span>
                        </Tooltip>
                      )}

                    {/* Close Request Button - Show when technician is assigned */}
                    {isTechnicianAssigned && canCloseTicketPermission && (
                      <Button
                        sx={stylesCss.actionButton}
                        onClick={() => {
                          setIsJobCompletedModalOpen(true);
                          setCurrentTicketId(value?._id);
                        }}
                        variant="contained"
                        color="primary"
                        disabled={
                          !value?.service_available ||
                          !value?.assigned_ids?.assigned_center_id?._id
                        }
                      >
                        Close Request
                      </Button>
                    )}
                  </>
                )}

                {/* Broadcast Button - Only show when no technician is assigned and ticket is not closed */}
                {!isTechnicianAssigned &&
                  !isClosed &&
                  canBroadcastTicketPermission && (
                    <Button
                      sx={{
                        ...stylesCss.actionButton,
                        backgroundColor: isBroadcastedValue ? "green" : "gray",
                        "&:hover": {
                          backgroundColor: isBroadcastedValue
                            ? "darkgreen"
                            : "darkgray",
                        },
                      }}
                      variant="contained"
                      onClick={() => handleBroadcastButtonClick(ticketId)}
                    >
                      {isBroadcastedValue ? "Broadcasted" : "Broadcast"}
                    </Button>
                  )}

                {/* Delete Button */}
                {canDeleteTicketPermission && (
                  <Tooltip title="Delete">
                    <Button
                      sx={stylesCss.smallActionButton}
                      style={{ background: "#FCE9F1" }}
                      onClick={() => clickDeleteTicket(value?._id)}
                    >
                      <DeleteIcon style={{ color: "red" }} />
                    </Button>
                  </Tooltip>
                )}

                {/* Rebook Button - Only for closed tickets */}
                {isClosed && canUpdateTicketPermission && (
                  <Tooltip title="Rebook">
                    <Button
                      sx={stylesCss.smallActionButton}
                      style={{
                        background: "#FCE9F1",
                      }}
                      onClick={() => handleRebookOpen(value?._id)}
                    >
                      <UpdateIcon style={{ color: "green" }} />
                    </Button>
                  </Tooltip>
                )}

                {/* Remarks Button */}
                {canRemarkTicketPermission && (
                  <Button
                    sx={{
                      ...stylesCss.actionButton,
                      backgroundColor: value?.remarks?.onboarding_team_remarks
                        ? "green !important"
                        : "FCE9F1 !important",
                    }}
                    onClick={() =>
                      handleRemarks(
                        value?._id,
                        reduxState.adminDetails.user_name,
                        value?.remarks?.onboarding_team_remarks,
                        value?.remarks?.onboarding_team_name
                      )
                    }
                    variant="contained"
                  >
                    Remarks
                  </Button>
                )}

                {value?.revisit_status == true && (
                  <Button
                    sx={stylesCss.actionButton}
                    style={{
                      backgroundColor: "purple",
                      color: "white",
                    }}
                    onClick={() => reopen(value?._id)}
                  >
                    Reopen-Log
                  </Button>
                )}
              </div>
            </>
          );
        },
      },
    },
  ];

  // Function to fetch technicians based on ticket status, service, and pincode
  const fetchTechniciansForTicket = async (ticketDetails) => {
    try {
      let technicians = [];

      if (ticketDetails.is_technician_assigned) {
        const centerId = ticketDetails.assigned_ids?.assigned_center_id?._id;
        if (centerId) {
          const response = await axios.get(
            `${BASE_URL}admin/api/center/${centerId}/technicians`
          );

          if (response.data.success) {
            technicians = response.data.data.map((technician) => ({
              _id: technician._id,
              name: technician.personal_details.name,
              pending_ticket_count:
                technician.count_details.pending_ticket_count,
              phone: technician.personal_details.primary_phone?.mobile_number,
              expertise: technician.service_details?.services_provided || [],
            }));
          }
        }
      } else {
        const serviceId = ticketDetails.service_provided_for?._id;
        const pincode = ticketDetails.address_details?.pincode;
        const city = ticketDetails.address_details?.city
          ? ticketDetails.address_details.city.toUpperCase()
          : "";

        if (!serviceId || !pincode) {
          throw new Error(
            `Service ID or Pincode not available for this ticket. Service: ${serviceId}, Pincode: ${pincode}`
          );
        }

        const params = {
          primary_services: serviceId,
          pincode: pincode,
        };

        const response = await axios.get(
          `${BASE_URL}admin/get-all-technician`,
          { params }
        );

        if (response.data.success) {
          technicians = response.data.data.map((technician) => ({
            _id: technician._id,
            name: technician.personal_details.name,
            pending_ticket_count: technician.count_details.pending_ticket_count,
            phone: technician.personal_details.primary_phone?.mobile_number,
            expertise: technician.service_details?.services_provided || [],
            city: technician.service_area?.city,
            pincodes: technician.service_area?.pincodes || [],
            is_active: technician.is_active,
            is_otp_verified: technician.is_otp_verified,
          }));

          if (technicians.length === 0) {
            console.log(
              "No technicians found with exact pincode, trying with service filter only..."
            );
          }
        }
      }

      return technicians;
    } catch (error) {
      console.error("Error fetching technicians:", error);
      throw error;
    }
  };

  const reopen = (id) => {
    navigate(`/reopen-log/${id}`);
  };

  const handleRemarks = (ticketId, username, initialRemarks, processedname) => {
    if (!canRemarkTicketPermission) {
      handleSnackbarOpen("You don't have permission to add remarks", "error");
      return;
    }
    setIsRemarksPopupOpen(true);
    setSelectedTicketId(ticketId);
    setUsername(username);
    setInitialRemarks(initialRemarks);
    setProcessedname(processedname);
  };

  const handleCloseRemarksPopup = () => {
    setIsRemarksPopupOpen(false);
    setSelectedTicketId(null);
  };

  const handleSaveRemarks = (ticketId, remarks, username) => {
    console.log("Ticket ID:", ticketId);
    console.log("Remarks:", remarks);
    console.log("Username:", username);
    handleCloseRemarksPopup();
  };

  const handleBroadcastButtonClick = async (ticketId) => {
    if (!canBroadcastTicketPermission) {
      handleSnackbarOpen(
        "You don't have permission to broadcast tickets",
        "error"
      );
      return;
    }

    const apiUrl = `${BASE_URL}technicianApp/ticket-broadcast`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ticket_obj_id: ticketId }),
      });

      if (!response.ok) {
        throw new Error("Failed to broadcast ticket");
      }

      setIsBroadcasted((prev) => ({
        ...prev,
        [ticketId]: true,
      }));
      setSnackbarMessage("Ticket broadcasted successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage("Failed to broadcast ticket!");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleEditTicket = (id) => {
    if (!canUpdateTicketPermission) {
      handleSnackbarOpen("You don't have permission to edit tickets", "error");
      return;
    }
    navigate("/admin-ticket?edit=" + id);
  };

  const handleViewTicket = (id) => {
    if (!canViewAllTicketsPermission && !canViewNormalTicketsPermission) {
      handleSnackbarOpen("You don't have permission to view tickets", "error");
      return;
    }
    window.open(`/#/view-ticket?ticketId=${id}`, '_blank');
  };

  const handleViewwTicket = (images, id) => {
    if (!canViewAllTicketsPermission && !canViewNormalTicketsPermission) {
      handleSnackbarOpen(
        "You don't have permission to view ticket images",
        "error"
      );
      return;
    }
    navigate("/ticketDocument", {
      state: { imageUrls: images, ticketId: id },
    });
  };

  const fetchMultipleImages = (data) => {
    const allImages = data.reduce((images, item) => {
      return images.concat(item.onsite_pictures || []);
    }, []);

    navigate("/ticketDocument", {
      state: { imageUrls: allImages },
    });
  };

  const clickDeleteTicket = (ticketId) => {
    if (!canDeleteTicketPermission) {
      handleSnackbarOpen(
        "You don't have permission to delete tickets",
        "error"
      );
      return;
    }
    setDeleteTicketId(ticketId);
    handleOpenCloseTicketDeleteModal(ticketId);
    localStorage.setItem("ticketId", ticketId);
  };

  const sameINA = (ticketDetails, callback) => {
    const payload = {
      ticket_obj_id: ticketDetails._id,
    };

    const apiUrl = `${BASE_URL}admin/get-center-for-ticket`;

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((res) => {
        callback(res.data);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const handleOpenTechnicianPopup = async (ticketDetails, isForChangeValue) => {
    if (!canAssignUnassignTicketPermission) {
      handleSnackbarOpen(
        "You don't have permission to assign technicians",
        "error"
      );
      return;
    }

    try {
      setIsLoading(true);
      const technicians = await fetchTechniciansForTicket(ticketDetails);

      setIsAssignTechnicianPopupOpen(true);
      setTicketDetailsForAssignTechnician(ticketDetails);
      setIsForChange(isForChangeValue);
      setTechnicianList(technicians);
    } catch (error) {
      console.error("Error opening technician popup:", error);
      handleSnackbarOpen("Failed to fetch technicians", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAssignTechnician = async (technicianId) => {
    if (!technicianId || !ticketDetailsForAssignTechnician?._id) {
      handleSnackbarOpen("Please select a technician", "error");
      return;
    }

    try {
      setIsTechnicianAssigning(true);

      const payload = {
        ticket_obj_id: ticketDetailsForAssignTechnician._id,
        technician_obj_id: technicianId,
      };

      const response = await axios.post(
        `${BASE_URL}admin/assigning-ticket-technician`,
        payload
      );

      if (response.data.success) {
        handleSnackbarOpen("Technician assigned successfully", "success");
        handleCloseAssignTechnicianPopup();
        getAllTickets(currentFilters);
      } else {
        throw new Error(response.data.message || "Failed to assign technician");
      }
    } catch (error) {
      console.error("Error assigning technician:", error);
      handleSnackbarOpen(
        error.response?.data?.message || "Failed to assign technician",
        "error"
      );
    } finally {
      setIsTechnicianAssigning(false);
    }
  };

  const handleChangeTechnician = async (technicianId) => {
    if (!technicianId || !ticketDetailsForAssignTechnician?._id) {
      handleSnackbarOpen("Please select a technician", "error");
      return;
    }

    try {
      setIsTechnicianAssigning(true);

      const centerId =
        ticketDetailsForAssignTechnician.assigned_ids?.assigned_center_id?._id;
      if (!centerId) {
        throw new Error("Center ID not found");
      }

      const payload = {
        ticket_obj_id: ticketDetailsForAssignTechnician._id,
        technician_obj_id: technicianId,
        center_id: centerId,
      };

      const response = await axios.post(
        `${BASE_URL}admin/assigning-ticket-technician`,
        payload
      );

      if (response.data.success) {
        handleSnackbarOpen("Technician changed successfully", "success");
        handleCloseAssignTechnicianPopup();
        getAllTickets(currentFilters);
      } else {
        throw new Error(response.data.message || "Failed to change technician");
      }
    } catch (error) {
      console.error("Error changing technician:", error);
      handleSnackbarOpen(
        error.response?.data?.message || "Failed to change technician",
        "error"
      );
    } finally {
      setIsTechnicianAssigning(false);
    }
  };

  const handleCloseAssignTechnicianPopup = () => {
    setIsAssignTechnicianPopupOpen(false);
    setTicketDetailsForAssignTechnician({});
    setTechnicianList([]);
    setIsTechnicianAssigning(false);
  };

  const handleSnackbarOpen = (message, severity = "success") => {
    setSnackbarOpen(true);
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
  };

  const handleOpenCloseTicketDeleteModal = () => {
    setIsDeleteAlertPopupOpen(true);
  };

  const onClickFilter = (value) => {
    if (!canViewTicketsPermission) {
      handleSnackbarOpen("You don't have permission to view tickets", "error");
      return;
    }

    const dateFilters = {
      start_date: value[0] ? moment(value[0]).format("YYYY-MM-DD") : null,
      end_date: value[1] ? moment(value[1]).format("YYYY-MM-DD") : null,
    };

    setFilters((prev) => ({ ...prev, ...dateFilters }));
    getAllTickets(dateFilters);
  };

  const refreshData = () => {
    if (!canViewTicketsPermission) {
      handleSnackbarOpen("You don't have permission to view tickets", "error");
      return;
    }

    startLoading();

    new AdminApiModule()
      .getAllTickets(currentFilters)
      .then((res) => {
        let parsedData = [];
        if (res?.data?.length) {
          parsedData = getParsedData(res.data);
        }
        setTicketsList(parsedData);
        stopLoading();
      })
      .catch((err) => {
        stopLoading();
        console.log(err);
      });
  };

  const startLoading = () => {
    setIsLoading(true);
  };

  const stopLoading = () => {
    setIsLoading(false);
  };

  const handleBroadCastTicket = (value) => {
    if (!canBroadcastTicketPermission) {
      handleSnackbarOpen(
        "You don't have permission to broadcast tickets",
        "error"
      );
      return;
    }

    let payload = {
      ticket_obj_id: value?._id,
    };
    new AdminApiModule()
      .adminBroadCast(payload)
      .then((res) => {
        getAllTickets();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleRevisitCloseTicket = (
    closingTicketRemarks,
    closingPrice,
    closingCode,
    reasonToClose,
    revisitRemark
  ) => {
    if (!canCloseTicketPermission) {
      handleSnackbarOpen("You don't have permission to close tickets", "error");
      return;
    }

    if (!(closingPrice == 0 || closingPrice)) {
      return;
    }

    if (closingTicketId && closingTicketId.length > 0) {
      let payload = {
        center_id: centerAssignId,
        ticket_obj_id: closingTicketId,
        remarks: {
          close_ticket_remarks: reasonToClose,
          technician_remarks: closingTicketRemarks,
          revisit_remarks: revisitRemark,
        },
        amount: parseInt(closingPrice),
        code: closingCode,
      };

      new AdminApiModule()
        .closeTicket(payload)
        .then((res) => {
          setClosingTicketId("");
          handleCloseCloseTicketRemarksModal();
          handleSnackbarOpen(true, "success", "Ticket closed successfully");
          getAllTickets(currentFilters);
        })
        .catch((err) => {
          console.log(err);
          handleSnackbarOpen(true, "error", err?.response?.data?.message);
        });
    }
  };

  const getAllTechnician = () => {
    new AdminApiModule()
      .getAllTechnician()
      .then((res) => {
        setTechnicianList(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleOpenEditPincodePopup = (value) => {
    if (!canUpdateTicketPermission) {
      handleSnackbarOpen(
        "You don't have permission to update ticket details",
        "error"
      );
      return;
    }
    setIsEditOpenAddressPincode(true);
    setIsEditOpenTicketDetails(value);
  };

  const handleApiCall = () => {
    setSelectedTicketIds([]);
  };

  const handleCloseEditPincodePopup = () => {
    setIsEditOpenAddressPincode(false);
    setIsEditOpenTicketDetails({});
  };

  useEffect(() => {
    if (canViewTicketsPermission && isInitialLoad) {
      const defaultFilters = {
        start_date: moment().subtract(1, "week").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      };
      setCurrentFilters(defaultFilters);
      getAllTechnician();
      // getAllTickets(defaultFilters);
      setIsInitialLoad(false);
    }
  }, [canViewTicketsPermission, isInitialLoad]);

  const getFormattedAddress = (addressObject) => {
    let addressLine =
      addressObject?.house_number +
      ", " +
      addressObject?.locality +
      ", " +
      addressObject?.city +
      ", " +
      addressObject?.state;
    return addressLine;
  };

  const getParsedData = (data) => {
    // Hide internal TIN-prefixed requests from the Requests table.
    const filteredData = (data || []).filter((item) => {
      const ticketId = String(item?.ticket_id || "").trim().toUpperCase();
      return !ticketId.startsWith("TIN");
    });

    let parsedData = filteredData?.map((item) => {
      let closingPrice = item?.closing_ticket_price;
      if (closingPrice === "-" || closingPrice === undefined) {
        closingPrice = 0;
      } else {
        closingPrice = parseFloat(closingPrice);
      }

      const technicianName =
        item?.assigned_ids?.assigned_technician_id?.personal_details?.name ||
        "";

      const isSuperAdmin =
        reduxState?.adminDetails?.admin_role === "SUPER_ADMIN";

      return {
        Created_at: new Date(item?.createdAt).toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        }),
        daysDifference: moment().diff(moment(item?.createdAt), "days"),
        Image: item?.onsite_pictures,
        ticket_id: item?.ticket_id || "-",
        Qr_Id: item?.assigned_ids?.assigned_center_id?.qr_details?.qr_id || "-",
        offer_code: item?.offers_applied?.offer_code || "-",
        center_id: item?.assigned_ids?.assigned_center_id?.center_name,
        technician_id: technicianName,
        technicianName: technicianName,
        service_required: `${item?.service_provided_for?.service_name?.slice(
          0,
          30
        )}...`,
        // Ensure service ID is available for technician filtering
        service_id: item?.service_provided_for?._id,
        service_name: item?.service_provided_for?.service_name,
        name: item.personal_details.name,
        phone:
          isSuperAdmin && canViewContactNumberPermission
            ? item.personal_details.primary_phone.mobile_number
            : "*****",
        alternate_phone_number:
          isSuperAdmin && canViewContactNumberPermission
            ? item.personal_details.alternate_phone.mobile_number
            : "*****",
        address: `${getFormattedAddress(item?.address_details).slice(
          0,
          30
        )}...`,
        pincode: item.address_details.pincode,
        // Ensure raw pincode is available
        raw_pincode: item.address_details.pincode,
        createdAt: new Date(item?.createdAt).toLocaleDateString("en-us", {
          year: "numeric",
          month: "short",
          day: "numeric",
        }),
        paidbypublic: item?.is_paid_by_public ? "YES" : "NO",
        client_id: item?.client_id || "-",
        client_name: item?.client_name || "-",
        specific_requirements: item?.specific_requirement
          ? item?.specific_requirement
          : "-",
        bstatus:
          item?.service_available == false
            ? "No Service Available In This Area "
            : item?.broadcast_status == "matched_in_same_center"
            ? "matched_in_same_center"
            : item?.broadcast_status == "broadcasted" &&
              item?.ticket_created_by == "PUBLIC_WITH_DELAR_QR"
            ? "DEALER"
            : item?.ticket_created_by == "SUPER_ADMIN" &&
              item?.broadcast_status == "accepted after broadcast"
            ? "Admin Created-Accepted"
            : item?.broadcast_status == "accepted after broadcast"
            ? "Public Created-Accepted"
            : item?.broadcast_status == undefined
            ? "Not Paid (Payment Failed)"
            : item?.broadcast_status == "broadcasted"
            ? `NEW ${
                (item?.is_paid_by_public == true && "99") ||
                (item?.is_paid_by_public == false &&
                  item?.ticket_created_by === "PUBLIC_WITH_CENTER_QR" &&
                  "NOT PAID")
              }`
            : `${item?.broadcast_status}` ||
              (item?.broadcast_status === undefined && "-"),
        tstatus:
          item?.ticket_status == "PENDING" &&
          item?.broadcast_status == "matched_in_same_center" &&
          technicianName
            ? "Technician Assigned"
            : item?.ticket_status == "PENDING" &&
              item?.broadcast_status == "matched_in_same_center" &&
              !technicianName
            ? "Technician Not Assigned"
            : item?.ticket_status == "ACCEPTED" && technicianName
            ? "Technician Assigned"
            : item?.ticket_status == "ACCEPTED" && !technicianName
            ? "Technician Not Assigned"
            : item?.ticket_status,
        tcreatedby:
          item?.ticket_created_by === "SUPER_ADMIN"
            ? item?.create_name
            : item?.ticket_created_by,
        Rating: item?.remarks?.over_all_rating,
        action: {
          ...item,
          // Ensure the raw data is available for technician filtering
          service_provided_for: item.service_provided_for,
          address_details: item.address_details,
          is_technician_assigned: item.is_technician_assigned,
          ticket_status: item.ticket_status,
        },
        closingPrice: closingPrice,
        timeprefrence: item?.time_preference?.specific_date_time
          ? new Date(item.time_preference.specific_date_time).toLocaleString(
              "en-IN",
              {
                timeZone: "Asia/Kolkata",
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: true,
              }
            )
          : item?.time_preference?.time_preference_type,
        paidbytechnician: item?.is_paid_by_technician ? "YES" : "NO",
        Center_QR: item?.created_by?.qr_details?.qr_id,
      };
    });

    return parsedData;
  };

  const getAllTickets = useCallback(
    (filterParams = {}) => {
      if (!canViewTicketsPermission) {
        handleSnackbarOpen("You don't have permission to view tickets");
        return;
      }

      startLoading();

      const payload = { ...filterParams };

      Object.keys(payload).forEach((key) => {
        if (
          payload[key] === "" ||
          payload[key] === null ||
          payload[key] === undefined
        ) {
          delete payload[key];
        }
      });

      new AdminApiModule()
        .getAllTickets(payload)
        .then((res) => {
          let parsedData = [];
          if (res?.data?.length) {
            parsedData = getParsedData(res.data);
          }
          setTicketsList(parsedData);
          stopLoading();
        })
        .catch((err) => {
          stopLoading();
          console.log(err);
          handleSnackbarOpen("Failed to fetch tickets", "error");
        });
    },
    [canViewTicketsPermission, currentFilters]
  );

  const handleFilterChange = (filterParams) => {
    setCurrentFilters(filterParams);
    getAllTickets(filterParams);
  };

  const handleClearFilters = (clearedFilters) => {
    getAllTickets(clearedFilters);
  };

  const handleUpdatePincode = (newPincode) => {
    if (!newPincode) {
      return;
    }
    let payload = {
      address_details: {
        pincode: newPincode,
      },
      ticket_obj_id: isEditOpenTicketDetails?._id,
    };

    setIsPincodeUpdating(true);
    new AdminApiModule()
      .updatePincode(payload)
      .then((res) => {
        setIsPincodeUpdating(false);
        getAllTickets(currentFilters);
        handleCloseEditPincodePopup();
      })
      .catch((err) => {
        setIsPincodeUpdating(false);
      });
  };

  const updateSelectedRowsClosingPrice = () => {
    let totalClosingPrice = 0;
    const selectedRowsClosingPrice = {};

    selectedTicketIds.forEach((ticketId) => {
      const rowData = ticketsList.find((row) => row.ticket_id === ticketId);
      if (rowData && rowData.closingPrice) {
        const closingPrice = parseFloat(rowData.closingPrice);
        if (!isNaN(closingPrice)) {
          totalClosingPrice += closingPrice;
          selectedRowsClosingPrice[ticketId] = closingPrice;
        }
      }
    });

    console.log("Selected Rows Closing Price:", selectedRowsClosingPrice);
    console.log("Total Closing Price:", totalClosingPrice);

    setSelectedRowsClosingPrice(selectedRowsClosingPrice);
    setTotalClosingPrice(totalClosingPrice);
  };

  const reportpage = () => {
    navigate("/report-page");
  };

  const handleCloseFileUploadErrors = () => {
    setDoesFileUploadErrorExists(false);
    setErrorsList({});
  };

  const handleCloseCloseTicketRemarksModal = () => {
    setIsCloseTicketRemarksModalOpen(false);
  };

  const handleDeleteCloseModal = () => {
    setIsDeleteAlertPopupOpen(false);
  };

  const handleDeleteRows = async () => {
    if (!canDeleteTicketPermission) {
      handleSnackbarOpen(
        "You don't have permission to delete tickets",
        "error"
      );
      return;
    }

    let accessToken = localStorage.getItem("access_token");
    let ticket_id = localStorage.getItem("ticketId");

    try {
      await axios.delete(`${BASE_URL}admin/deleteTickets/${ticket_id}`, {
        headers: {
          "x-access-token": accessToken,
        },
      });
      handleDeleteCloseModal();
      getAllTickets(currentFilters);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteSelectedRows = () => {
    console.log("=========", selectedTicketIds);
    selectedTicketIds.forEach((ticketId) => {
      clickDeleteTicket(ticketId);
    });

    setSelectedTicketIds([]);
  };

  const handleRebookOpen = (rebookTicketId) => {
    if (!canUpdateTicketPermission) {
      handleSnackbarOpen(
        "You don't have permission to rebook tickets",
        "error"
      );
      return;
    }
    setRebookTicketId(rebookTicketId);
    setOpenRebook(true);
  };

  const handleRebookClose = () => setOpenRebook(false);

  // If user doesn't have permission to view tickets, show access denied message
  if (!canViewTicketsPermission) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
          fontSize: "18px",
          color: "red",
          fontWeight: "bold",
        }}
      >
        Access Denied - You don't have permission to view tickets
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <RebookModal
        isOpen={openRebook}
        handleRebookOpen={handleRebookOpen}
        handleRebookClose={handleRebookClose}
        Ticket_id={rebookTicketId}
      />

      <TicketFilters
        onFilterChange={handleFilterChange}
        onClearFilters={handleClearFilters}
        isLoading={isLoading}
      />

      <JobCompletedModal
        open={isJobCompletedModalOpen}
        onClose={() => {
          setIsJobCompletedModalOpen(false);
        }}
        onSuccess={() => {
          setIsJobCompletedModalOpen(false);
          getAllTickets(currentFilters);
          handleSnackbarOpen("Ticket closed successfully", "success");
        }}
        ticketId={currentTicketId}
      />

      {isCloseTicketRemarksModalOpen && (
        <CloseTicketRemarksModal
          open={isCloseTicketRemarksModalOpen}
          handleClose={handleCloseCloseTicketRemarksModal}
          handleCloseTicket={handleRevisitCloseTicket}
          getSingleTicketData={getSingleTicketData?.results}
        />
      )}

      {isEditOpenAddressPincode && (
        <TicketEditPincodePopup
          open={isEditOpenAddressPincode}
          isPincodeUpdating={isPincodeUpdating}
          handleUpdatePincode={handleUpdatePincode}
          handleClose={handleCloseEditPincodePopup}
          isEditOpenTicketDetails={isEditOpenTicketDetails}
        />
      )}

      {isDeleteAlertPopupOpen && (
        <DeleteAlertDialogModal
          openAlert={isDeleteAlertPopupOpen}
          handleAlertClose={handleDeleteCloseModal}
          handleDeleteTicket={handleDeleteRows}
          Heading={deleteHeading}
        />
      )}

      <RemarksPopup
        open={isRemarksPopupOpen}
        handleClose={handleCloseRemarksPopup}
        onSaveRemarks={handleSaveRemarks}
        selectedTicketId={selectedTicketId}
        username={username}
        initialRemarks={initialRemarks}
        processedname={processedname}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
        onClick={stopLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Grid container>
        <Grid
          style={stylesCss.paddingInnerGrids}
          item
          md={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div className="aadhar-upload-button">
            <Button
              variant="contained"
              style={{
                backgroundColor: "green",
                color: "white",
                fontSize: "0.3rem",
                padding: "8px 10px",
                borderRadius: "0",
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "38px",
                width: "70px",
              }}
            >
              <h1>PAID</h1>
              <div>
                <h1>{totalClosingPrice}</h1>
              </div>
            </Button>

            <Button
              onClick={reportpage}
              variant="contained"
              component="span"
              style={{
                height: "37px",
                width: "120px",
                fontWeight: "bold",
              }}
            >
              Analysis
            </Button>

            <Snackbar
              open={snackbarOpen}
              autoHideDuration={3000}
              onClose={handleSnackbarClose}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert
                onClose={handleSnackbarClose}
                severity={snackbarSeverity}
                sx={{ width: "100%" }}
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>
          </div>
        </Grid>
      </Grid>

      {isAssignTechnicianPopupOpen && (
        <AssignTechnicianPopup
          open={isAssignTechnicianPopupOpen}
          handleClose={handleCloseAssignTechnicianPopup}
          technicianList={technicianList}
          isForChange={isForChange}
          ticketDetailsForAssignTechnician={ticketDetailsForAssignTechnician}
          isTechnicianAssigning={isTechnicianAssigning}
          handleAssignTechnician={handleAssignTechnician}
          handleChangeTechnician={handleChangeTechnician}
          ticketObjId={ticketDetailsForAssignTechnician?._id}
          centerlist={centerlist}
        />
      )}

      <MUIDataTable
        title={"Requests"}
        data={ticketsList}
        columns={columns}
        options={{
          ...options,
          selectableRows: "multiple",
          onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
            const selectedIds = allRowsSelected.map(
              (row) => ticketsList[row.dataIndex].ticket_id
            );
            setSelectedTicketIds(selectedIds);
            updateSelectedRowsClosingPrice();
          },
        }}
      />

      {doesFileUploadErrorExists && (
        <FileUploadErrors
          doesFileUploadErrorExists={doesFileUploadErrorExists}
          errorsList={errorsList}
          handleCloseFileUploadErrors={handleCloseFileUploadErrors}
        />
      )}
    </div>
  );
};

export default Tickets;
